import { saveDeletTeamIdActions } from "./action";

const initialState = {
  deletePartnerTeamData: null,
};

const saveDeleteTeamIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveDeletTeamIdActions.SAVE_DELETE_TEAM_PERSONID_SUCCESS:
      return {
        ...state,
        deletePartnerBranchData: action.payload.data,
      };
    case saveDeletTeamIdActions.SAVE_DELETE_TEAM_PERSONID_SUCCESS:
      return {
        ...state,
        deletePartnerBranchData: [],
      };

    default:
      return state;
  }
};

export default saveDeleteTeamIdReducer;
